// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SharedStyles__inlineStatistic___vAk7X {
	padding-left: 0.3em;
}


.SharedStyles__inlineStatistic___vAk7X a,
.SharedStyles__inlineStatistic___vAk7X button {
	color: #b7b7b7;
}

.SharedStyles__marginRightHalfem___Nf56_ {
	margin-right: 0.5em;
}

.SharedStyles__marginTopHalfem___BAW4y {
	margin-top: 0.5em;
}

.SharedStyles__marginBottom1em___oBNdu {
	margin-bottom: 1em;
}

.SharedStyles__flashOpacity___tMYlR {
	animation-name: SharedStyles__flashOpacityKeyframes___VWZ9J;
	animation-duration: 5s;
	animation-iteration-count: infinite;
	animation-direction: alternate;
	animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);
}

@keyframes SharedStyles__flashOpacityKeyframes___VWZ9J {
	from {
		opacity: 1;
	}

	to {
		opacity: 0.3;
	}
}

.SharedStyles__flash___wKEmQ {
	animation-name: SharedStyles__flashColorKeyframes___Trwwt;
	animation-duration: 3s;
	animation-iteration-count: infinite;
	animation-direction: alternate;
	animation-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);
}

@keyframes SharedStyles__flashColorKeyframes___Trwwt {
	from {
	}

	to {
		color: white;
	}
}

.SharedStyles__metDailyTargetGlow___Bhz9O {
	text-shadow: gold 0px 0px 12px;
}

@keyframes SharedStyles__fadeInKeyframes___QiPNl {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineStatistic": `SharedStyles__inlineStatistic___vAk7X`,
	"marginRightHalfem": `SharedStyles__marginRightHalfem___Nf56_`,
	"marginTopHalfem": `SharedStyles__marginTopHalfem___BAW4y`,
	"marginBottom1em": `SharedStyles__marginBottom1em___oBNdu`,
	"flashOpacity": `SharedStyles__flashOpacity___tMYlR`,
	"flashOpacityKeyframes": `SharedStyles__flashOpacityKeyframes___VWZ9J`,
	"flash": `SharedStyles__flash___wKEmQ`,
	"flashColorKeyframes": `SharedStyles__flashColorKeyframes___Trwwt`,
	"metDailyTargetGlow": `SharedStyles__metDailyTargetGlow___Bhz9O`,
	"fadeInKeyframes": `SharedStyles__fadeInKeyframes___QiPNl`
};
module.exports = ___CSS_LOADER_EXPORT___;
